<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15lyUx5/tc-custom/9781421400891.jpg?1704761626286" alt="This image is the cover for the book Money over Mastery, Family over Freedom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Money over Mastery, Family over Freedom
      </h1>
      <p class="bookDescription body article font2">
        <b>“Elegantly argued . . . convincingly shows the centrality of enslaved men and women to the transformation of the coastal upper South’s commercial life.” —<i>The</i><i>Journal of Southern History</i></b><br/><br/>Once a sleepy plantation society, the region from the Chesapeake Bay to coastal North Carolina modernized and diversified its economy in the years before the Civil War. Central to this industrializing process was slave labor. <i>Money over Mastery, Family over Freedom</i> tells the story of how slaves seized opportunities in these conditions to protect their family members from the auction block.<br/><br/>Calvin Schermerhorn argues that the African American family provided the key to economic growth in the antebellum Chesapeake. To maximize profits in the burgeoning regional industries, slaveholders needed to employ or hire out a healthy supply of strong slaves, which tended to scatter family members. From each generation, they also selected the young, fit, and fertile for sale or removal to the cotton South. Conscious of this pattern, the enslaved were sometimes able to negotiate mutually beneficial labor terms—to save their families despite that new economy.<br/><br/><i>Money over Mastery, Family over Freedom</i> proposes a new way of understanding the role of American slaves in the antebellum marketplace. Rather than work against it, as one might suppose, enslaved people engaged with the market somewhat as did free Americans. Slaves focused their energy and attention, however, not on making money, as slaveholders increasingly did, but on keeping their kin out of the human coffles of the slave trade.<br/><br/><b>“Displays exhaustive research, a well-crafted argument, and is a valuable addition to antebellum slave historiography.” —<i>H-CivWar</i>, <i>H-Net Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Calvin Schermerhorn
      </h2>
      
      <p class="authorDescription body article">Calvin Schermerhorn is an assistant professor of history at Arizona State University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6358972e